module.exports = __webpack_public_path__ + "static/media/7.b2633a0f.png";